import React, { useEffect } from 'react'
import { FieldHookConfig, useField, useFormikContext } from 'formik'
import AsyncSelect from 'react-select/async'
import { FormatOptionLabelMeta, OptionTypeBase } from 'react-select'

type AsyncSelectFieldProps = {
    loadOptions: (inputString: string) => Promise<OptionTypeBase[]>
    noOptionsMessage: () => string
    formatOptionLabel: (option: OptionTypeBase, labelMeta: FormatOptionLabelMeta<OptionTypeBase, boolean>) => React.ReactNode
}

const LoadingIndicator = () => {
    return <img src="/spinning-circles.svg" alt="loading" style={{ width:'2rem', height: '2rem' }} />
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const AsyncSelectField: React.FC<FieldHookConfig<string> | AsyncSelectFieldProps | any> = (props) => {
    const objectSuffix = '__object'

    const fieldProps = { ...props as FieldHookConfig<string> }
    const selectProps = { ...props as AsyncSelectFieldProps }

    const { setFieldValue } = useFormikContext()
    const [field] = useField(props as FieldHookConfig<string>)
    const [fieldObject] = useField(field.name + objectSuffix)

    useEffect(()=>{
        if(!field.value) {
            setFieldValue(field.name, null)
            setFieldValue(fieldObject.name, null)
        }
    }, [field.value, setFieldValue, field.name, fieldObject.name])

    return <>
        <AsyncSelect
            {...selectProps}
            className={(fieldProps.className || '') + ' reactSelect'}
            name={fieldProps.name + objectSuffix}
            // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
            value={fieldObject.value}
            cacheOptions
            isClearable

            components={{ LoadingIndicator: LoadingIndicator }}

            onChange={(value: OptionTypeBase | null) => {
                setFieldValue(field.name, value?.value)
                setFieldValue(fieldObject.name, value?.value ? value : null)
            }} />
        <input
            name={field.name}
            value={field?.value || ''}
            type="hidden" />
    </>
}
